import globalCn from './global/global-cn'
import loginCn from './login/login-cn'
import homeCn from './home/home-cn'
import deviceCn from './device/device-cn'
import logCn from './logs/log-cn'
import orgCn from './org/org-cn'
import alarmCn from './alarm/alarm-cn'
import superviseCn from './supervise/supervise-cn'
import menuCn from './menu/menu-cn'
import searchCn from './search/search-cn'
import columnCheck from './columnCheck/columnCheck-cn'
import setting from './setting/setting-cn'
const cn = {
  global: globalCn,
  login: loginCn,
  home: homeCn,
  alarm: alarmCn,
  device: deviceCn,
  org: orgCn,
  log: logCn,
  supervise: superviseCn,
  menu: menuCn,
  search: searchCn,
  columnCheck: columnCheck,
  setting: setting
}
export default cn